import React from "react";
import { GetServerSidePropsContext } from "next";
import Cors from "cors";
import cookie from "cookie";
import initMiddleware from "../util/initMiddleware";
import forceHttps from "../util/force-https";
import dynamic from "next/dynamic";
import { prepareRedirectHref } from "util/prepareRedirectHref";

const cors = initMiddleware(
  Cors({
    methods: ["GET", "POST", "OPTIONS"],
    origin: "*",
    exposedHeaders: "*",
    credentials: true,
    optionsSuccessStatus: 200,
  })
);

const RegisterPage = dynamic(
  () => import("../pageComponents/Register/Register")
);

export default function Register(props: {
  country?: string;
  startCountry?: string;
}) {
  const { country, startCountry, ...rest } = props;

  return (
    <RegisterPage
      {...rest}
      noindex={true}
      nofollow={true}
      srcUrl="//code.metalocator.com/index.php?option=com_locator&view=directory&layout=_javascript&framed=1&format=raw&tmpl=component&no_html=1&Itemid=15507"
    />
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  forceHttps(context);
  await cors(context.req, context.res);

  const cookies = cookie.parse(
    context.req ? context.req.headers.cookie || "" : document.cookie
  );

  const country = cookies.country || null;
  return {
    props: {
      country,
    },

    redirect: {
      destination: prepareRedirectHref(context.resolvedUrl),
      permanent: true,
    },
  };
}
